// LocalesConfig.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./Locales/en";
import ar from "./Locales/ar";

const savedLanguage = localStorage.getItem("preferredLanguage") || "en";
i18n.use(initReactI18next).init({
  fallbackLng: "en", // Default language
  debug: false  , // Enable debugging during development
  lng: savedLanguage, // Initialize i18n with saved language
  interpolation: {
    escapeValue: false, // React already handles escaping
  },
  resources: {
    en: {
      translation: en,
    },
    ar: {
      translation: ar,
    },
  },
});

export default i18n;
